module.exports = __webpack_public_path__ + "static/media/messenger.c01bc110.mp3";